
module.exports = { 
      attributes: {},
    
      body: "# About US\n\nRubber baby buggy bumper.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/wqphn/content/static/default/about.md"},
     }